export type VoiceDiagnosticSource = 'client' | 'server'

export interface VoiceDiagnosticInput {
  source: VoiceDiagnosticSource
  stage: string
  details: Record<string, unknown>
  timestamp?: string
}

export interface VoiceDiagnosticEvent extends VoiceDiagnosticInput {
  timestamp: string
}

export class VoiceDiagnosticStore {
  private events: VoiceDiagnosticEvent[] = []
  private listeners = new Set<() => void>()

  record(input: VoiceDiagnosticInput): void {
    const event: VoiceDiagnosticEvent = {
      ...input,
      timestamp: input.timestamp ?? new Date().toISOString(),
    }
    this.events = [...this.events.slice(-39), event]
    console.info('[K-VIBE voice debug]', event)
    this.listeners.forEach((listener) => listener())
  }

  getRecent(): VoiceDiagnosticEvent[] {
    return this.events
  }

  subscribe(listener: () => void): () => void {
    this.listeners.add(listener)
    return () => this.listeners.delete(listener)
  }
}

export const voiceDiagnostics = new VoiceDiagnosticStore()
